<template>
  <div
    class="baseDataList"
    @contextmenu="handleContextmenu"
    v-loading="options.tableLoading"
  >
    <el-button
      v-loading="loadingExport"
      type="primary"
      icon="el-icon-download"
      size="mini"
      v-if="exportFlag && btnType.indexOf('6005') !== -1"
      @click="exportData()"
      class="export_btn"
      :style="{ left: leftPx }"
    >
      导出数据
    </el-button>
    <vxe-toolbar
      class-name="vxe_toolbar_box"
      ref="xToolbar1"
      custom
    ></vxe-toolbar>
    <vxe-table
      class="mytable-scrollbar"
      :header-row-class-name="showSearch ? 'h_80' : 'h_44'"
      stripe
      :row-class-name="getRowClassName"
      :sort-config="{ sortMethod: customSortMethod }"
      :tooltip-config="{ zIndex: 9999 }"
      :row-style="rowStyle"
      :custom-config="customConfig"
      :keyboard-config="{ isArrow: false }"
      :id="$route.path"
      ref="xTable1"
      border
      :min-height="diaHeight || options.minHeight"
      :height="options.height"
      show-overflow
      :data="options.dataList"
      :column-config="{ resizable: true }"
      :scroll-y="{ enabled: true }"
      align="center"
      :row-config="{
        keyField: 'id',
        isCurrent: true,
      }"
      :tree-config="
        isTree
          ? {
              transform: true,
              rowField: 'id',
              parentField: 'parentCode',
              reserve: true,
              expandAll: true,
            }
          : {}
      "
      :menu-config="menu >= 0 ? options.tableMenu : {}"
      @menu-click="contextMenuClickEvent"
      :edit-config="{ trigger: ['dblclick', 'click'], mode: 'cell' }"
      :header-cell-style="headerStyle"
      @radio-change="radioChangeEvent"
      @cell-click="cellClick"
      @cell-dblclick="cellDblclick"
      :span-method="mergeRowMethod"
      @checkbox-change="selectChangeEvent"
      @checkbox-all="changeMultpleCheck"
    >
      >
      <vxe-column
        type="seq"
        width="80"
        align="center"
        :edit-render="{ autofocus: '.vxe-input--inner' }"
      >
        <template #header="{ column }">
          <div class="table_column_title_text">序号</div>
          <el-button
            size="mini"
            type="primary"
            v-if="showSearch"
            @click="getTableList"
            >查询</el-button
          >
        </template>
      </vxe-column>
      <vxe-column
        v-for="config in tableHeader"
        :key="config.key"
        :title="config.title"
        :type="config.type"
        :field="config.field"
        :width="config.type != 'checkbox' ? config.width : 70"
        :show-overflow="config.title != '操作'"
        min-width="140px"
        :sortable="
          (config.title.indexOf('日期') >= 0 ||
            config.title.indexOf('时间') >= 0 ||
            config.title == '进出门次数') &&
          config.title != '打卡时间'
            ? true
            : false
        "
        :align="config.align"
        :fixed="config.fixedTable"
      >
        <!-- hideCondition  隐藏条件 -->
        <template
          #header="{ column, row, checked, indeterminate }"
          v-if="
            config.title !== '操作' &&
            !config.hideCondition &&
            config.type != 'checkbox'
          "
        >
          <template>
            <div class="table_column_title_text">
              {{ config.title }}
            </div>
          </template>
          <template v-if="!noSearch">
            <template v-if="!config.slotSearch">
              <!-- <template v-if="config.title == '多选'">
                <vxe-checkbox
                  v-model="multpleCheck"
                  @change="changeMultpleCheck"
                ></vxe-checkbox>
              </template> -->
              <template v-if="config.title == '单选'"> </template>
              <template v-else-if="config.title.indexOf('审批结果') >= 0">
                <el-select
                  v-model="inputFrom[config.field]"
                  size="mini"
                  clearable
                  placeholder=""
                  @change="getTableList"
                >
                  <el-option label="通过" :value="1"></el-option>
                  <el-option label="驳回" :value="0"></el-option>
                  <el-option label="已取消" :value="2"></el-option>
                </el-select>
              </template>
              <template
                v-else-if="
                  config.title.indexOf('是否') >= 0 &&
                  !['whether', 'lateFlag'].includes(config.keyType) &&
                  config.title != '是否购买五险'
                "
              >
                <el-select
                  v-model="inputFrom[config.field]"
                  size="mini"
                  clearable
                  placeholder=""
                  @change="getTableList"
                >
                  <el-option label="是" value="1"></el-option>
                  <el-option label="否" value="0"></el-option>
                </el-select>
              </template>
              <template v-else-if="config.keyType == 'whether'">
                <el-select
                  v-model="inputFrom[config.field]"
                  size="mini"
                  clearable
                  placeholder=""
                  @change="getTableList"
                >
                  <el-option label="是" value="1"></el-option>
                  <el-option label="否" value="0"></el-option>
                  <el-option label="异常" value="2"></el-option>
                </el-select>
              </template>
              <template v-else-if="config.title == '是否购买五险'">
                <el-select
                  v-model="inputFrom[config.field]"
                  size="mini"
                  clearable
                  placeholder=""
                  @change="getTableList"
                >
                  <el-option label="是" value="1"></el-option>
                  <el-option label="否" value="0"></el-option>
                </el-select>
              </template>
              <!-- 是否迟到 -->
              <template v-else-if="config.keyType == 'lateFlag'">
                <el-select
                  v-model="inputFrom[config.field]"
                  size="mini"
                  clearable
                  placeholder=""
                  @change="getTableList"
                >
                  <el-option label="正常" value="0"></el-option>
                  <el-option label="上午迟到" value="1"></el-option>
                  <el-option label="下午迟到" value="2"></el-option>
                  <el-option label="上午下午迟到" value="3"></el-option>
                </el-select>
              </template>
              <template v-else-if="config.keyType == 'dayNum'">
                <el-select
                  v-model="inputFrom[config.field]"
                  size="mini"
                  clearable
                  placeholder=""
                  @change="getTableList"
                >
                  <el-option label="0" value="0"></el-option>
                  <el-option label="0.5" value="0.5"></el-option>
                  <el-option label="1" value="1"></el-option>
                </el-select>
              </template>
              <template v-else-if="config.keyType == 'replaceNum'">
                <el-select
                  v-model="inputFrom[config.field]"
                  size="mini"
                  clearable
                  placeholder=""
                  @change="getTableList"
                >
                  <el-option label="0" value="0"></el-option>
                  <el-option label="1" value="1"></el-option>
                  <el-option label="2" value="2"></el-option>
                  <el-option label="3" value="3"></el-option>
                  <el-option label="4" value="4"></el-option>
                </el-select>
              </template>
              <template v-else-if="config.keyType == 'subsidy'">
                <el-select
                  v-model="inputFrom[config.field]"
                  size="mini"
                  clearable
                  placeholder=""
                  @change="getTableList"
                >
                  <el-option label="45" value="45"></el-option>
                  <el-option label="80" value="80"></el-option>
                </el-select>
              </template>
              <!-- 出勤天数 -->
              <template v-else-if="config.keyType == 'attendanceDay'">
                <el-select
                  v-model="inputFrom[config.field]"
                  size="mini"
                  clearable
                  placeholder=""
                  @change="getTableList"
                >
                  <el-option
                    :label="item.attendanceDays"
                    :value="item.attendanceDays"
                    v-for="item in attendanceDayList"
                    :key="item.attendanceDays"
                  ></el-option>
                </el-select>
              </template>
              <template v-else-if="config.typeNum">
                <template v-if="config.typeNum == 'num'">
                  <el-input-number
                    size="mini"
                    v-model="inputFrom[config.field]"
                    controls-position="right"
                    :min="0"
                    style="width: 96%"
                    @change="getTableList"
                  ></el-input-number>
                </template>
                <template v-if="config.typeNum == 'floatNum'">
                  <el-input-number
                    size="mini"
                    v-model="inputFrom[config.field]"
                    controls-position="right"
                    :min="0"
                    :precision="1"
                    style="width: 96%"
                    @change="getTableList"
                  ></el-input-number>
                </template>
              </template>
              <template v-else-if="config.typeTime">
                <template v-if="config.typeTime == 'time'">
                  <el-time-picker
                    size="mini"
                    v-model="inputFrom[config.field]"
                    placeholder=""
                    value-format="HH:mm:ss"
                    @change="getTableList"
                  >
                  </el-time-picker>
                </template>
                <template v-else-if="config.typeTime == 'dates'">
                  <el-date-picker
                    v-model="dateList[config.field]"
                    size="mini"
                    type="daterange"
                    value-format="yyyy-MM-dd"
                    range-separator="~"
                    start-placeholder=""
                    end-placeholder=""
                    :editable="false"
                    @change="datesChange($event, config.field)"
                  >
                  </el-date-picker>
                </template>
                <template v-else-if="config.typeTime == 'datesSend'">
                  <el-date-picker
                    v-model="dateList[config.field]"
                    size="mini"
                    type="daterange"
                    value-format="yyyy-MM-dd"
                    range-separator="~"
                    start-placeholder=""
                    end-placeholder=""
                    :editable="false"
                    @change="datesChangeSend($event, config.field)"
                  >
                  </el-date-picker>
                </template>
                <template v-else-if="config.typeTime == 'datem'">
                  <el-date-picker
                    v-model="inputFrom[config.field]"
                    type="month"
                    size="mini"
                    value-format="yyyy-MM"
                    placeholder=""
                    :editable="false"
                    @change="getTableList"
                  >
                  </el-date-picker>
                </template>
                <template v-else>
                  <el-date-picker
                    v-model="inputFrom[config.field]"
                    type="date"
                    size="mini"
                    :value-format="'yyyy-MM-dd'"
                    clearable
                    :editable="false"
                    @change="getTableList"
                    @clear="getTableList"
                  >
                  </el-date-picker>
                </template>
              </template>
              <template v-else-if="config.title == '统计日期'">
                <el-date-picker
                  v-model="useTime"
                  size="mini"
                  type="daterange"
                  format="yyyy-MM-dd"
                  value-format="yyyy-MM-dd"
                  range-separator="~"
                  start-placeholder=""
                  end-placeholder=""
                  :editable="false"
                  @change="getDate($event, '统计日期')"
                >
                </el-date-picker>
              </template>
              <template v-else-if="config.title == '考勤日期'">
                <el-date-picker
                  v-model="attendDate"
                  size="mini"
                  type="daterange"
                  format="yyyy-MM-dd"
                  value-format="yyyy-MM-dd"
                  range-separator="~"
                  start-placeholder=""
                  end-placeholder=""
                  :editable="false"
                  @change="getDate($event, '考勤日期')"
                >
                </el-date-picker>
              </template>
              <template v-else-if="config.title == '试用到期时间'">
                <el-date-picker
                  v-model="useTime"
                  size="mini"
                  type="daterange"
                  format="yyyy-MM-dd"
                  value-format="yyyy-MM-dd"
                  range-separator="~"
                  start-placeholder=""
                  end-placeholder=""
                  :editable="false"
                  @change="getDate($event, '试用到期时间')"
                >
                </el-date-picker>
              </template>
              <template v-else-if="config.title == '用车时间'">
                <el-date-picker
                  v-model="useTime"
                  size="mini"
                  type="daterange"
                  format="yyyy-MM-dd"
                  value-format="yyyy-MM-dd"
                  range-separator="~"
                  start-placeholder=""
                  end-placeholder=""
                  :editable="false"
                  @change="getDate($event, '用车时间')"
                >
                </el-date-picker>
              </template>
              <template v-else-if="config.title == '客人到达时间'">
                <el-date-picker
                  v-model="guestArrivalTime"
                  size="mini"
                  type="daterange"
                  format="yyyy-MM-dd hh:mm"
                  value-format="yyyy-MM-dd hh:mm"
                  range-separator="~"
                  start-placeholder=""
                  end-placeholder=""
                  :editable="false"
                  @change="getDate($event, '申请时间')"
                >
                </el-date-picker>
              </template>
              <template v-else-if="config.title == '委外日期'">
                <el-date-picker
                  v-model="useTime"
                  size="mini"
                  type="daterange"
                  format="yyyy-MM-dd"
                  value-format="yyyy-MM-dd"
                  range-separator="~"
                  start-placeholder=""
                  end-placeholder=""
                  :editable="false"
                  @change="getDate($event, '委外日期')"
                >
                </el-date-picker>
              </template>
              <template v-else-if="config.title == '设备返厂时间'">
                <el-date-picker
                  v-model="useTime"
                  size="mini"
                  type="daterange"
                  format="yyyy-MM-dd"
                  value-format="yyyy-MM-dd"
                  range-separator="~"
                  start-placeholder=""
                  end-placeholder=""
                  :editable="false"
                  @change="getDate($event, '设备返厂时间')"
                >
                </el-date-picker>
              </template>
              <template v-else-if="config.title == '申请时间'">
                <el-date-picker
                  v-model="applyDate"
                  size="mini"
                  type="daterange"
                  value-format="yyyy-MM-dd"
                  range-separator="~"
                  start-placeholder=""
                  end-placeholder=""
                  :editable="false"
                  @change="getDate($event, '申请时间')"
                >
                </el-date-picker>
              </template>
              <template v-else-if="config.title == '创建时间'">
                <el-date-picker
                  v-model="createDate"
                  size="mini"
                  type="daterange"
                  value-format="yyyy-MM-dd"
                  range-separator="~"
                  start-placeholder=""
                  end-placeholder=""
                  :editable="false"
                  @change="getDate($event, '创建时间')"
                >
                </el-date-picker>
              </template>
              <template v-else-if="config.title == '修改时间'">
                <el-date-picker
                  v-model="updateDate"
                  size="mini"
                  type="daterange"
                  value-format="yyyy-MM-dd"
                  range-separator="~"
                  start-placeholder=""
                  end-placeholder=""
                  :editable="false"
                  @change="getDate($event, '修改时间')"
                >
                </el-date-picker>
              </template>
              <template v-else-if="config.keyType == 'clockDate'">
                <el-date-picker
                  v-model="clockDate"
                  size="mini"
                  type="daterange"
                  value-format="yyyy-MM-dd"
                  range-separator="~"
                  start-placeholder=""
                  end-placeholder=""
                  :editable="false"
                  @change="getDate($event, 'clockDate')"
                >
                </el-date-picker>
              </template>
              <template v-else-if="config.title == '开始时间'">
                <el-date-picker
                  v-model="inputFrom.startTime"
                  type="date"
                  size="mini"
                  :value-format="'yyyy-MM-dd'"
                  clearable
                  :editable="false"
                  @change="getTableList"
                  @clear="getTableList"
                >
                </el-date-picker>
              </template>
              <template v-else-if="config.title == '结束时间'">
                <el-date-picker
                  v-model="inputFrom.endTime"
                  type="date"
                  size="mini"
                  :value-format="'yyyy-MM-dd'"
                  clearable
                  :editable="false"
                  @change="getTableList"
                  @clear="getTableList"
                >
                </el-date-picker>
              </template>
              <template v-else-if="config.keyType == 'dateTime'">
                <el-date-picker
                  v-model="inputFrom[config.field]"
                  type="date"
                  size="mini"
                  :value-format="'yyyy-MM-dd'"
                  :editable="false"
                  clearable
                  @change="getTableList"
                  @clear="getTableList"
                >
                </el-date-picker>
              </template>
              <template v-else-if="config.title == '状态'">
                <el-select
                  v-model="inputFrom[config.field]"
                  size="mini"
                  clearable
                  placeholder=""
                  @change="getTableList"
                >
                  <el-option
                    v-for="(item, index) in recruitmentMethodList"
                    :key="item.code"
                    :label="item.name"
                    :value="item.code"
                  ></el-option>
                </el-select>
              </template>
              <template v-else-if="config.title == '节假日配置'">
                <MultipleSelect
                  :disabledFlag="
                    holidayConfigMainList.length > 0 && !config.disabled
                      ? false
                      : true
                  "
                  :selectOptions="holidayConfigMainList"
                  :deployObj="{
                    label: 'title',
                    value: 'id',
                  }"
                  field="holidayConfigMainIds"
                  :arr="inputFrom.holidayConfigMainIds || []"
                  @visibleChange="
                    visibleChangeCode($event, 'holidayConfigMainIds')
                  "
                ></MultipleSelect>
              </template>
              <template v-else-if="config.title == '审批状态'">
                <MultipleSelect
                  :selectOptions="checkStatusOptions"
                  :deployObj="{
                    label: 'label',
                    value: 'value',
                  }"
                  field="checkStatus"
                  :arr="inputFrom.checkStatusList || []"
                  @visibleChange="visibleChangeCode($event, 'checkStatusList')"
                ></MultipleSelect>
              </template>
              <template v-else-if="config.title == '上级部门'">
                <MultipleSelect
                  :disabledFlag="
                    parentDeptList.length > 0 && !config.disabled ? false : true
                  "
                  :selectOptions="parentDeptList"
                  :deployObj="{
                    label: 'deptName',
                    value: 'id',
                  }"
                  field="parentDeptIds"
                  :arr="inputFrom.parentDeptIds || []"
                  @visibleChange="visibleChangeCode($event, 'parentDeptIds')"
                ></MultipleSelect>
              </template>
              <template v-else-if="config.title == '岗位上级部门'">
                <MultipleSelect
                  :disabledFlag="
                    parentDeptListPositions.length > 0 && !config.disabled
                      ? false
                      : true
                  "
                  :selectOptions="parentDeptListPositions"
                  :deployObj="{
                    label: 'deptName',
                    value: 'id',
                  }"
                  field="parentDeptIds"
                  :arr="inputFrom.parentDeptIds || []"
                  @visibleChange="visibleChangeCode($event, 'parentDeptIds')"
                ></MultipleSelect>
              </template>
              <template v-else-if="config.title == '使用者部门'">
                <MultipleSelect
                  :disabledFlag="
                    DeptList.length > 0 && !config.disabled ? false : true
                  "
                  :selectOptions="DeptList"
                  :deployObj="{
                    label: 'deptName',
                    value: 'id',
                  }"
                  field="userDeptId"
                  :arr="inputFrom.deptIds || []"
                  @visibleChange="visibleChangeCode($event, 'userDeptId')"
                ></MultipleSelect>
              </template>
              <template v-else-if="config.title == '档案位置部门'">
                <MultipleSelect
                  :disabledFlag="
                    DeptList.length > 0 && !config.disabled ? false : true
                  "
                  :selectOptions="DeptList"
                  :deployObj="{
                    label: 'nameUrl',
                    value: 'id',
                  }"
                  field="deptIds"
                  :arr="inputFrom.deptIds || []"
                  @visibleChange="visibleChangeCode($event, 'deptIds')"
                ></MultipleSelect>
              </template>
              <template v-else-if="config.title == '所属员工部门'">
                <MultipleSelect
                  :disabledFlag="
                    DeptList.length > 0 && !config.disabled ? false : true
                  "
                  :selectOptions="DeptList"
                  :deployObj="{
                    label: 'nameUrl',
                    value: 'id',
                  }"
                  field="deptIds"
                  :arr="inputFrom.deptIds || []"
                  @visibleChange="visibleChangeCode($event, 'deptIds')"
                ></MultipleSelect>
              </template>
              <template v-else-if="config.title == '档案汇总部门'">
                <MultipleSelect
                  :disabledFlag="
                    DeptList.length > 0 && !config.disabled ? false : true
                  "
                  :selectOptions="DeptList"
                  :deployObj="{
                    label: 'nameUrl',
                    value: 'id',
                  }"
                  field="deptIds"
                  :arr="inputFrom.documentLocationDeptIds || []"
                  @visibleChange="
                    visibleChangeCode($event, 'documentLocationDeptIds')
                  "
                ></MultipleSelect>
              </template>
              <template v-else-if="config.keyType == 'dept'">
                <MultipleSelect
                  :disabledFlag="
                    empolyDeptList.length > 0 && !config.disabled ? false : true
                  "
                  :selectOptions="empolyDeptList"
                  :deployObj="{
                    label: 'deptName',
                    value: 'id',
                  }"
                  field="deptIds"
                  :arr="inputFrom.deptIds || []"
                  @visibleChange="visibleChangeCode($event, 'deptIds')"
                ></MultipleSelect>
              </template>
              <template v-else-if="config.title == '选择员工部门'">
                <MultipleSelect
                  :disabledFlag="
                    DeptList.length && !config.disabled ? false : true
                  "
                  :selectOptions="DeptList"
                  :deployObj="{
                    label: 'nameUrl',
                    value: 'id',
                  }"
                  field="deptIds"
                  :arr="inputFrom.deptIds || []"
                  @visibleChange="visibleChangeCode($event, 'deptIds')"
                ></MultipleSelect>
              </template>
              <template
                v-else-if="
                  config.title.indexOf('部门') >= 0 &&
                  config.title != '使用者部门' &&
                  config.title != '上级部门' &&
                  config.title != '调出部门' &&
                  config.title != '档案位置部门' &&
                  config.title != '选择员工部门' &&
                  config.keyType != 'dept' &&
                  config.title != '档案汇总部门' &&
                  config.title != '所属员工部门'
                "
              >
                <MultipleSelect
                  :disabledFlag="
                    DeptList.length > 0 && !config.disabled ? false : true
                  "
                  :selectOptions="DeptList"
                  :deployObj="{
                    label: 'nameUrl',
                    value: 'id',
                  }"
                  field="deptIds"
                  :arr="inputFrom.deptIds || []"
                  @visibleChange="visibleChangeCode($event, 'deptIds')"
                ></MultipleSelect>
              </template>
              <template v-else-if="config.keyType == 'unit'">
                <MultipleSelect
                  :disabledFlag="
                    orgBusinessUnitList.length > 0 && !config.disabled
                      ? false
                      : true
                  "
                  :selectOptions="orgBusinessUnitList"
                  :deployObj="{
                    label: 'deptName',
                    value: 'id',
                  }"
                  :arr="inputFrom.orgBusinessUnitIds || []"
                  @visibleChange="
                    visibleChangeCode($event, 'orgBusinessUnitIds')
                  "
                ></MultipleSelect>
              </template>
              <template v-else-if="config.title.indexOf('事业部') >= 0">
                <MultipleSelect
                  :disabledFlag="
                    businessUnitList.length > 0 && !config.disabled
                      ? false
                      : true
                  "
                  :selectOptions="businessUnitList"
                  :deployObj="{
                    label: 'deptName',
                    value: 'id',
                  }"
                  :arr="inputFrom.businessUnitIds || []"
                  @visibleChange="visibleChangeCode($event, 'businessUnitIds')"
                ></MultipleSelect>
              </template>
              <template v-else-if="config.title == '车间'">
                <MultipleSelect
                  :disabledFlag="workshopIdsList.length > 0 ? false : true"
                  :selectOptions="workshopIdsList"
                  :deployObj="{
                    label: 'deptName',
                    value: 'id',
                  }"
                  :arr="inputFrom.workshopIds || []"
                  @visibleChange="visibleChangeCode($event, 'workshopIds')"
                ></MultipleSelect>
              </template>
              <template
                v-else-if="
                  config.title.indexOf('班组') >= 0 &&
                  config.title != '调出班组' &&
                  config.title != '车间班组'
                "
              >
                <MultipleSelect
                  :disabledFlag="teamIdsList.length > 0 ? false : true"
                  :selectOptions="teamIdsList"
                  :deployObj="{
                    label: 'deptName',
                    value: 'id',
                  }"
                  :arr="inputFrom.teamIds || []"
                  @visibleChange="visibleChangeCode($event, 'teamIds')"
                ></MultipleSelect>
              </template>
              <template
                v-else-if="
                  config.title.indexOf('岗位') >= 0 &&
                  config.title != '岗位来源单号' &&
                  config.title != '调出岗位' &&
                  config.title != '档案岗位名称' &&
                  config.title != '员工岗位'
                "
              >
                <MultipleSelect
                  :disabledFlag="positionList.length > 0 ? false : true"
                  :selectOptions="positionList"
                  :deployObj="{
                    label: 'positionAbr',
                    value: 'id',
                  }"
                  :arr="inputFrom.positionIds || []"
                  @visibleChange="visibleChangeCode($event, 'positionIds')"
                ></MultipleSelect>
              </template>
              <template v-else-if="config.title == '调出部门'">
                <MultipleSelect
                  :disabledFlag="
                    orgDeptIdsList.length > 0 && !config.disabled ? false : true
                  "
                  :selectOptions="orgDeptIdsList"
                  :deployObj="{
                    label: 'deptName',
                    value: 'id',
                  }"
                  field="orgDeptIds"
                  :arr="inputFrom.orgDeptIds || []"
                  @visibleChange="visibleChangeOrgCode($event, 'orgDeptIds')"
                ></MultipleSelect>
              </template>
              <template v-else-if="config.title == '调出班组'">
                <MultipleSelect
                  :disabledFlag="orgTeamIdsList.length > 0 ? false : true"
                  :selectOptions="orgTeamIdsList"
                  :deployObj="{
                    label: 'deptName',
                    value: 'id',
                  }"
                  :arr="inputFrom.orgTeamIds || []"
                  @visibleChange="visibleChangeOrgCode($event, 'orgTeamIds')"
                ></MultipleSelect>
              </template>
              <template v-else-if="config.title == '调出岗位'">
                <MultipleSelect
                  :disabledFlag="orgPositionIdsList.length > 0 ? false : true"
                  :selectOptions="orgPositionIdsList"
                  :deployObj="{
                    label: 'positionAbr',
                    value: 'id',
                  }"
                  :arr="inputFrom.orgPositionIds || []"
                  @visibleChange="
                    visibleChangeOrgCode($event, 'orgPositionIds')
                  "
                ></MultipleSelect>
              </template>
              <template v-else-if="config.title == '班次'">
                <MultipleSelect
                  :disabledFlag="classesList.length > 0 ? false : true"
                  :selectOptions="classesList"
                  :deployObj="{
                    label: 'name',
                    value: 'id',
                  }"
                  :arr="inputFrom.classesIds || []"
                  @visibleChange="visibleChangeCode($event, 'classesIds')"
                ></MultipleSelect>
              </template>
              <template v-else-if="config.title == '打卡班次'">
                <MultipleSelect
                  :selectOptions="shiftManageList"
                  :deployObj="{
                    label: 'name',
                    value: 'id',
                  }"
                  field="shiftManageIds"
                  :arr="inputFrom.shiftManageIds || []"
                  @visibleChange="visibleChangeCode($event, 'shiftManageIds')"
                ></MultipleSelect>
              </template>
              <template v-else-if="config.typeCode">
                <template v-if="config.field.indexOf('Name') != -1">
                  <el-select
                    v-model="
                      inputFrom[
                        `${config.field.slice(0, config.field.length - 4)}`
                      ]
                    "
                    size="mini"
                    clearable
                    placeholder=""
                    @change="getTableList"
                  >
                    <el-option
                      v-for="item in codeData.find(
                        (ele) => ele.code == config.typeCode
                      ).children"
                      :key="item.id"
                      :label="item.name"
                      :value="item.code"
                    ></el-option>
                  </el-select>
                </template>
                <template v-else-if="config.field.indexOf('Value') != -1">
                  <el-select
                    v-model="
                      inputFrom[
                        `${config.field.slice(0, config.field.length - 5)}`
                      ]
                    "
                    size="mini"
                    clearable
                    placeholder=""
                    @change="getTableList"
                  >
                    <el-option
                      v-for="item in codeData.find(
                        (ele) => ele.code == config.typeCode
                      ).children"
                      :key="item.id"
                      :label="item.name"
                      :value="item.code"
                    ></el-option>
                  </el-select>
                </template>
                <template v-else>
                  <el-select
                    v-model="inputFrom[config.field]"
                    size="mini"
                    clearable
                    placeholder=""
                    @change="getTableList"
                  >
                    <el-option
                      v-for="item in codeData.find(
                        (ele) => ele.code == config.typeCode
                      ).children"
                      :key="item.id"
                      :label="item.name"
                      :value="item.code"
                    ></el-option>
                  </el-select>
                </template>
              </template>
              <template v-else-if="config.typeCodes">
                <template v-if="config.field.indexOf('Name') != -1">
                  <MultipleSelect
                    :selectOptions="
                      codeData.find((ele) => ele.code == config.typeCodes)
                        .children
                    "
                    :deployObj="deployCode"
                    :arr="
                      inputFrom[
                        `${config.field.slice(0, config.field.length - 4)}`
                      ] || []
                    "
                    @visibleChange="
                      visibleChangeCode(
                        $event,
                        `${config.field.slice(0, config.field.length - 4)}`
                      )
                    "
                  ></MultipleSelect>
                </template>
                <template v-else>
                  <MultipleSelect
                    :selectOptions="
                      codeData.find((ele) => ele.code == config.typeCodes)
                        .children
                    "
                    :deployObj="deployCode"
                    :arr="inputFrom[`${config.field}`] || []"
                    @visibleChange="visibleChangeCode($event, config.field)"
                  ></MultipleSelect>
                </template>
              </template>
              <template v-else-if="config.number">
                <el-input
                  ref="numberInputRef"
                  clearable
                  size="mini"
                  @keyup.enter.native="getTableList"
                  v-model="inputFrom[column.field]"
                  @clear="numberInputClear()"
                  oninput="value=value.replace(/[^\d.]/g,'')"
                ></el-input>
              </template>
              <template v-else>
                <el-input
                  ref="inputRef"
                  clearable
                  :disabled="config.inputDisabled ? true : false"
                  size="mini"
                  @keyup.enter.native="getTableList"
                  v-model="inputFrom[column.field]"
                  @clear="inputClear()"
                ></el-input>
              </template>
            </template>
            <template v-else>
              <slot :name="config.slotSearch" :item="row"></slot>
            </template>
          </template>
        </template>
        <template #default="{ row }">
          <template v-if="config.title === '操作'">
            <slot :name="config.slotName" :item="row"></slot>
          </template>
          <template v-else>
            <template v-if="config.slotName">
              <slot :name="config.slotName" :item="row"></slot>
            </template>
            <template v-else>
              {{ row[config.field] }}
            </template>
          </template>
        </template>
      </vxe-column>
    </vxe-table>
    <vxe-pager
      style="display: block; margin-top: 5px"
      size="small"
      v-if="isPager"
      :loading="loading1"
      :current-page="tablePage1.currentPage"
      :page-size="tablePage1.pageSize"
      :total="tablePage1.totalResult"
      :layouts="[
        'PrevPage',
        'JumpNumber',
        'NextPage',
        'FullJump',
        'Sizes',
        'Total',
      ]"
      :page-sizes="[100, 300, 500]"
      @page-change="handlePageChange1"
    >
    </vxe-pager>
  </div>
</template>

<script>
import http from '@/api/ajax/aixos'
import axios from 'axios'
import dayjs from 'dayjs'
import {
  getDeptDropdown,
  queryAllShfitManage,
  getAllPositionByDeptId,
  queryCommunicationOrderDropdown,
  queryCheckStatusList,
  queryEmployeeAttendanceDays,
} from '@/api/ajax/index'
import { queryHolidayMainPageList, getUserMenuBtn } from '@/api/ajax/request'
export default {
  name: 'baseDataList',
  props: {
    showSearch: {
      type: Boolean,
      default: true, //是否显示搜索按钮，若为false 搜索按钮隐藏，watch监听searchForm内取消执行getTableList方法
    },
    leftPx: {
      type: String,
      default: '85px',
    },
    tableHeader: {
      type: Array,
      require: true,
    },
    noSearch: {
      type: Boolean,
      require: false,
    },
    exportFlag: {
      type: Boolean,
      require: false,
    },
    //isTree控制是否是树型结构
    isTree: {
      type: Boolean,
      default: false,
    },
    //是否展示分页
    isPager: {
      type: Boolean,
      default: false,
    },
    url: {
      type: String,
      require: true,
    },
    searchForm: {
      type: Object,
      default: {},
    },
    // 高亮指定行参数
    currentObj: {
      type: Object,
      default: () => {
        return {}
      },
    },
    mergeRow: {
      type: String,
      default: '',
    },
    diaHeight: {
      type: String,
      default: '',
    },
    isColor: {
      type: Boolean,
      default: true,
    },
    checkStatusParams: {
      type: Array,
      default: () => [],
    },
    pageSize: {
      type: Number,
      default: 100,
    },
    isAttendanceDay: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      timeout: null, //防抖定时器
      selectSet: new Set(), //存储选中ID
      selectData: [], //选中数据数组
      loadingExport: false,
      multpleCheck: false,
      customConfig: {
        storage: true,
        allowFixed: false,
        checkMethod: ({ column }) => {
          if (column.title === '序号' || column.title === '操作') {
            return false
          } else {
            return true
          }
        },
      },
      dateList: {},
      orgDeptIdsList: [],
      orgTeamIdsList: [],
      orgPositionIdsList: [],
      workshopIdsList: [],
      deployCode: {
        label: 'name',
        value: 'code',
      },
      isSearchFlag: true,
      copyText: '',
      shiftManageList: [],
      headerStyle: {
        // background: 'rgb(238,241,246)',
        height: '20px',
        color: '#606266',
        padding: '6px 0',
        // lineHeight: '22px',
      },
      recruitmentMethodList: [],
      allAlign: null,
      options: {
        minHeight: ' ',
        height: ' ',
        maxHeight: ' ',
        //初始化菜单
        tableMenu: {
          // className: 'my-menus',
          body: {
            options: [
              [
                {
                  code: 'rest',
                  name: '刷新',
                },
                // {
                //   code: 'edit',
                //   name: '编辑',
                // },
                // {
                //   code: 'del',
                //   name: '删除',
                // },
                {
                  code: 'copy',
                  name: '复制',
                },
                {
                  code: 'paste',
                  name: '粘贴',
                },
              ],
            ],
          },
        },
        tableLoading: false, //整个组件loading
        dataList: [], //list接口数据
        // 默认树形标识是code 和parentCode 更改的话在父组件传递 和url平级
        treeConfig: {
          rowField: 'code',
          parentField: 'parentCode',
        },
        url: '', // 请求接口
      },
      loading1: false,
      tablePage1: {
        currentPage: 1,
        pageSize: this.pageSize,
        totalResult: 0,
      },
      inputFrom: {},
      DeptList: [],
      businessUnitList: [],
      orgBusinessUnitList: [],
      teamIdsList: [],
      classesList: [],
      positionList: [],
      useTime: [],
      attendDate: [],
      guestArrivalTime: [],
      applyDate: [], // 申请时间
      createDate: [], // 创建时间
      updateDate: [], // 修改时间
      clockDate: [], //打卡时间
      parentDeptList: [],
      parentDeptListPositions: [],
      holidayConfigMainList: [],
      checkStatusOptions: [], // 审批状态数组
      empolyDeptList: [],
      attendanceDayList: [],
    }
  },
  watch: {
    searchForm: {
      handler(val, old) {
        this.inputFrom = { ...this.inputFrom, ...val }
        this.dateList = {
          dealTime: [this.inputFrom.dealStartTime, this.inputFrom.dealEndTime],
        }
        if (val.clockStartTime) {
          this.clockDate = [val.clockStartTime, val.clockEndTime]
        }
        if (val.attendanceStartDate || val.attendanceEndDate) {
          this.$set(
            this.inputFrom,
            'attendanceStartDate',
            dayjs(val.attendanceStartDate).format('YYYY-MM-DD')
          )
          this.$set(
            this.inputFrom,
            'attendanceEndDate',
            dayjs(val.attendanceEndDate).format('YYYY-MM-DD')
          )
          this.attendDate = [
            dayjs(val.attendanceStartDate).format('YYYY-MM-DD'),
            dayjs(val.attendanceEndDate).format('YYYY-MM-DD'),
          ]
        }
        if (this.showSearch) {
          // 事业部名称存在话联动部门名称
          if (val.businessUnitIds && val.businessUnitIds.length) {
            this.getDeptDropdownWord({
              parentIds: val.businessUnitIds,
            })
          }
          if (val.deptIds && val.deptIds.length) {
            this.getTeamIds()
          }
          this.getTableList()
        }
      },
      immediate: true,
      deep: true,
    },
  },
  computed: {
    menu() {
      let flag = this.tableHeader.findIndex((ele) => ele.title == '操作')
      return flag
    },
    btnType() {
      return this.$store.state.wdstore.btnManage.btnStr
    },
    codeData() {
      return this.$store.state.wdstore.code
    },
  },
  activated() {
    this.getUserMenuBtn()
  },
  created() {
    this.__calculateHeight()
    let findDept = this.tableHeader.find(
      (ele) => ele.title.indexOf('部门') >= 0
    )
    let findDeptOne = this.tableHeader.find(
      (ele) => ele.keyType && ele.keyType.indexOf('1001') >= 0
    )
    let shiye = this.tableHeader.find((ele) => ele.title.indexOf('事业部') >= 0)
    let orgshiye = this.tableHeader.find(
      (ele) => ele.keyType && ele.keyType.indexOf('unit') >= 0
    )
    let banzu = this.tableHeader.find((ele) => ele.title == '班组名称')
    let className = this.tableHeader.find(
      (ele) =>
        ele.title == '班次' ||
        this.tableHeader.find((ele) => ele.title == '打卡班次')
    )
    let positionName = this.tableHeader.find((ele) => ele.title == '岗位')
    if (findDept) {
      this.getDeptDropdown({ level: '2,3' })
    }
    if (!!findDeptOne) {
      this.getDeptDropdown({ level: '2,3,4' })
    }
    if (shiye) {
      this.getDeptDropdown({ level: '2' })
    }
    if (!!orgshiye) {
      this.getOrgDeptDropdown({ level: '2' })
    }

    // if (banzu) {
    //   this.queryTeamPageList()
    // }
    if (className) {
      this.queryAllShfitManage()
    }
    if (this.tableHeader.find((ele) => ele.title == '通知单号')) {
      this.queryCommunicationOrderDropdown()
    }
    if (this.tableHeader.find((ele) => ele.title == '上级部门')) {
      this.getParentDeptList()
    }
    if (this.tableHeader.find((ele) => ele.title == '岗位上级部门')) {
      this.getParentDeptListPositions()
    }
    // if (this.tableHeader.find((ele) => ele.title == '调出部门')) {
    //   this.getOrgDeptIds()
    // }
    if (
      this.tableHeader.find(
        (ele) =>
          ele.title == '档案位置部门' ||
          ele.title == '所属员工部门' ||
          ele.title == '档案汇总部门'
      )
    ) {
      this.getDeptDropdown({ level: '2,3' })
    }
    if (this.tableHeader.find((ele) => ele.title == '选择员工部门')) {
      this.getDeptDropdown({ level: '1,2,3,4' })
    }
    if (this.tableHeader.find((ele) => ele.title == '节假日配置')) {
      this.getholidayMainList()
    }
    if (this.tableHeader.find((ele) => ele.title == '审批状态')) {
      this.queryCheckStatusList()
    }
    if (this.tableHeader.find((ele) => ele.title == '考勤日期')) {
      let now = new Date()
      let startDate = new Date(now.getFullYear(), now.getMonth(), 1)
      let endDate = now
      this.$set(
        this.inputFrom,
        'attendanceStartDate',
        dayjs(startDate).format('YYYY-MM-DD')
      )
      this.$set(
        this.inputFrom,
        'attendanceEndDate',
        dayjs(endDate).format('YYYY-MM-DD')
      )
      this.attendDate = [
        dayjs(startDate).format('YYYY-MM-DD'),
        dayjs(endDate).format('YYYY-MM-DD'),
      ]
    }
  },
  mounted() {
    console.log('???')
  },
  methods: {
    inputClear() {
      // 点击清除按钮自动失去输入框焦点
      this.$refs.inputRef.map((item) => {
        item.blur()
      })
      this.getTableList()
    },
    // 数字类型输入框清除事件
    numberInputClear() {
      this.$refs.numberInputRef.map((item) => {
        item.blur()
      })
      this.getTableList()
    },
    // 获取出勤天数下拉
    getAttendanceDayList() {
      queryEmployeeAttendanceDays(this.inputFrom).then((res) => {
        this.attendanceDayList = res.data || []
        console.log(res, '获取出勤天数下拉')
      })
    },
    // 如果需要销毁弹窗内容，回显选中数据时父组件需要调用该方法
    selectFn(oldSelectArr) {
      oldSelectArr.forEach((element) => {
        this.selectSet.add(String(element.id)) //临时存储选中数据
        this.selectData.push(element)
      })
    },
    // 获取审批状态列表
    async queryCheckStatusList() {
      const res = await queryCheckStatusList({
        businessKeyList: this.checkStatusParams,
      })
      if (res.code == 200 && res.data) {
        this.checkStatusOptions = res.data.map((item) => {
          return {
            label: item,
            value: item,
          }
        })
      }
    },
    // 排序
    customSortMethod({ data, sortList }) {
      const sortItem = sortList[0]
      const { field, order } = sortItem
      let list = data
      if (order === 'asc') {
        list.sort(function (a, b) {
          return b[field] < a[field] ? 1 : -1
        })
      }
      if (order === 'desc') {
        list.sort(function (a, b) {
          return b[field] < a[field] ? -1 : 1
        })
      }
      return list
    },
    // 获取按钮权限
    async getUserMenuBtn() {
      let path = ''
      if (this.$route.fullPath.indexOf('?') > 0) {
        path = this.$route.fullPath.split('?')[0]
      } else {
        path = this.$route.fullPath
      }
      const res = await getUserMenuBtn({
        path: path,
      })
      if (res.code == 200) {
        let btnData = {
          btnStr: res.data.btnStr || '',
          menuId: res.data.menuId || '',
        }
        localStorage.setItem('btnManage', JSON.stringify(btnData))
        this.$store.commit('wdstore/setBtnManage', btnData)
      }
    },
    //导出模板
    exportData() {
      this.loadingExport = true
      let params = {
        page: this.tablePage1.currentPage,
        limit: this.tablePage1.pageSize,
        ...this.inputFrom,
      }
      // const res = downloadFile(params, this.$route.meta.title)
      let filename = this.$route.meta.title
      let url = process.env.VUE_APP_BASEURL + '/CGP-OA/common/exportData' //后端的接口
      let param = {
        request: JSON.stringify(params),
        exportName: filename,
      }
      axios
        .post(url, param, {
          responseType: 'blob',
          headers: {
            'X-Access-Token': window.localStorage.getItem('accessToken'),
          },
        })
        .then((res) => {
          if (res.status == 200) {
            filename = filename + '.xlsx'
            let blob = new Blob([res.data], {
              type: res.headers['content-type'],
            })
            let url = window.URL.createObjectURL(blob)
            if (window.navigator.msSaveBlob) {
              //IE
              try {
                window.navigator.msSaveBlob(blob, filename)
              } catch (e) {
                console.log(e)
              }
            } else {
              //非IE
              let link = document.createElement('a')
              link.style.display = 'none'
              link.href = url
              link.setAttribute('download', filename)
              document.body.appendChild(link)
              link.click()
            }
            URL.revokeObjectURL(url) // 释放内存
          }
        })
        .finally(() => {
          this.loadingExport = false
          this.$emit('exportDataStatus', false)
        })
    },
    visibleChangeCode(e, field) {
      this.inputFrom[field] = e
      console.log(this.inputFrom, 888)
      if (field == 'deptIds') {
        if (e.length == 0) {
          this.inputFrom.positionIds = []
          this.positionList = []
          this.inputFrom.teamIds = []
          this.teamIdsList = []
        } else {
          let flag = false
          let flag1 = false
          this.tableHeader.map((item) => {
            if (item.title.indexOf('班组') >= 0) {
              flag = true
            }
            if (item.title.indexOf('岗位') >= 0) {
              flag1 = true
            }
          })
          if (flag) {
            this.getTeamIds()
          }
          if (flag1) {
            this.getAllPositionByDeptId()
          }
        }
      } else if (field == 'teamIds') {
        if (e.length == 0) {
          this.inputFrom.positionIds = []
          this.positionList = []
        } else {
          let flag = false
          this.tableHeader.map((item) => {
            if (item.title.indexOf('部门') >= 0) {
              flag = true
            }
          })
          if (flag) {
            this.getAllPositionByDeptId(1)
          }
        }
      }
      if (field == 'parentDeptId') {
        if (e.length == 0) {
          this.DeptList = []
        } else {
          this.getDeptDropdown({ parentIds: e })
        }
      }
      if (field == 'businessUnitIds') {
        if (e.length == 0) {
          this.workshopIds = []
          this.workshopIdsList = []
          this.inputFrom.deptIds = []
          this.empolyDeptList = []
        } else {
          this.getDeptDropdownWord({ parentIds: e })
        }
      }
      if (field == 'orgBusinessUnitIds') {
        if (e.length == 0) {
          this.inputFrom.orgDeptIds = []
        } else {
          this.getOrgDeptDropdownWord({ parentIds: e })
        }
      }
      if (field == 'workshopIds') {
        if (e.length == 0) {
          this.inputFrom.teamIds = []
          this.teamIdsList = []
        } else {
          this.getDeptDropdownTeam({ parentIds: e })
        }
      }
      this.getTableList()
    },
    visibleChangeOrgCode(e, field) {
      this.inputFrom[field] = e
      if (field == 'orgDeptIds') {
        if (e.length == 0) {
          this.inputFrom.orgTeamIds = []
          this.orgTeamIdsList = []
          this.inputFrom.orgPositionIds = []
          this.orgPositionIdsList = []
        } else {
          this.getOrgTeamIds()
        }
      } else if (field == 'orgTeamIds') {
        if (e.length == 0) {
          this.inputFrom.orgPositionIds = []
          this.orgPositionIdsList = []
        } else {
          this.getOrgPositionIdsList()
        }
      }
      this.getTableList()
    },
    datesChangeSend(e, text) {
      if (!e) {
        if (text == 'sendStartTime') {
          this.inputFrom.sendStartTime = ''
          this.inputFrom.sendEndTime = ''
        } else if (text == 'dealTime') {
          this.inputFrom.dealStartTime = ''
          this.inputFrom.dealEndTime = ''
        }
      } else {
        if (text == 'sendStartTime') {
          this.inputFrom.sendStartTime = e[0]
          this.inputFrom.sendEndTime = e[1]
        } else if (text == 'dealTime') {
          this.inputFrom.dealStartTime = e[0]
          this.inputFrom.dealEndTime = e[1]
        }
      }
      this.getTableList()
    },
    datesChange(e, text) {
      let length = text.length
      let start =
        text.substring(0, length - 4) + 'Start' + text.substring(length - 4)
      let end =
        text.substring(0, length - 4) + 'End' + text.substring(length - 4)
      if (!e) {
        this.inputFrom[start] = ''
        this.inputFrom[end] = ''
      } else {
        console.log(e, text, start, end)
        if (text == 'attendanceTime') {
          this.inputFrom[start] = e[0] + ' 00:00:00'
          this.inputFrom[end] = e[1] + ' 23:59:59'
        } else {
          this.inputFrom[start] = e[0]
          this.inputFrom[end] = e[1]
        }
      }
      this.getTableList()
    },
    getDate(e, text) {
      switch (text) {
        case '创建时间':
          this.inputFrom.createStartTime = !e ? '' : e[0]
          this.inputFrom.createEndTime = !e ? '' : e[1]
          break
        case '修改时间':
          this.inputFrom.updateStartTime = !e ? '' : e[0]
          this.inputFrom.updateEndTime = !e ? '' : e[1]
          break
        case '申请时间':
          this.inputFrom.applyStartTime = !e ? '' : e[0]
          this.inputFrom.applyEndTime = !e ? '' : e[1]
          break
        case '用车时间':
          this.inputFrom.useStartTime = !e ? '' : e[0]
          this.inputFrom.useEndTime = !e ? '' : e[1]
          break
        case '客人到达时间':
          this.inputFrom.guestArrivalStartTime = !e ? '' : e[0]
          this.inputFrom.guestArrivalEndTime = !e ? '' : e[1]
          break
        case '委外时间':
          this.inputFrom.outsourceStartDate = !e ? '' : e[0]
          this.inputFrom.outsourceEndDate = !e ? '' : e[1]
          break
        case '设备返厂时间':
          this.inputFrom.returnRepairStartDate = !e ? '' : e[0]
          this.inputFrom.returnRepairEndDate = !e ? '' : e[1]
          break
        case '考勤日期':
          this.inputFrom.attendanceStartDate = !e ? '' : e[0]
          this.inputFrom.attendanceEndDate = !e ? '' : e[1]
          break
        case '统计日期':
          this.inputFrom.startDate = !e ? '' : e[0]
          this.inputFrom.endDate = !e ? '' : e[1]
          break
        case '试用到期时间':
          this.inputFrom.probationaryStartDate = !e ? '' : e[0]
          this.inputFrom.probationaryEndDate = !e ? '' : e[1]
          break
        case 'clockDate':
          this.inputFrom.clockStartTime = !e ? '' : e[0] + ' 00:00:00'
          this.inputFrom.clockEndTime = !e ? '' : e[1] + ' 23:59:59'
          break
      }
      this.getTableList()
    },
    // 节假日日期配置
    async getholidayMainList() {
      const res = await queryHolidayMainPageList({
        page: 1,
        limit: 999,
      })
      this.holidayConfigMainList = res.data.list
    },
    // 获取部门下拉
    async getDeptDropdown(params) {
      const res = await getDeptDropdown(params)
      this.DeptList = res.data
      if (params.level == 2) {
        this.businessUnitList = res.data
      }
    },
    // 获取部门下拉org
    async getOrgDeptDropdown(params) {
      const res = await getDeptDropdown(params)
      if (params.level == 2) {
        this.orgBusinessUnitList = res.data
      }
    },
    // 通过事业部id查询
    async getDeptDropdownWord(params) {
      const res = await getDeptDropdown(params)
      this.workshopIdsList = res.data
      this.empolyDeptList = res.data
      if (this.empolyDeptList.length == 0) {
        this.getAllPositionByDeptId(1)
      }
    },
    // 通过事业部id查询org
    async getOrgDeptDropdownWord(params) {
      const res = await getDeptDropdown(params)
      this.orgDeptIdsList = res.data
    },
    // 通过车间id查询班组
    async getDeptDropdownTeam(params) {
      const res = await getDeptDropdown(params)
      this.teamIdsList = res.data
    },
    async getParentDeptList() {
      const res = await getDeptDropdown({ level: 2 })
      this.parentDeptList = res.data
    },
    async getParentDeptListPositions() {
      const res = await getDeptDropdown({ level: '1,2,3' })
      this.parentDeptListPositions = res.data
    },
    // 获取调出部门树
    async getOrgDeptIds() {
      const res = await getDeptDropdown()
      this.orgDeptIdsList = res.data
    },
    // 获取调出班组
    async getOrgTeamIds() {
      const res = await getDeptDropdown({
        parentIds: this.inputFrom.orgDeptIds,
      })
      this.orgTeamIdsList = res.data
      if (this.orgTeamIdsList.length == 0) {
        this.getOrgPositionIdsList()
      }
    },
    // 根据调出部门id获取岗位
    async getOrgPositionIdsList() {
      if (!this.inputFrom.orgDeptIds || !this.inputFrom.orgTeamIds) {
        this.orgPositionIdsList = []
      } else {
        let params = {}
        if (this.inputFrom.orgTeamIds && this.inputFrom.orgTeamIds.length > 0) {
          params.deptIds = this.inputFrom.orgTeamIds
        } else if (
          this.inputFrom.orgDeptIds &&
          this.inputFrom.orgDeptIds.length > 0
        ) {
          params.deptIds = this.inputFrom.orgDeptIds
        } else {
          params.deptIds = this.inputFrom.businessUnitList
        }
        const res = await getAllPositionByDeptId(params)
        this.orgPositionIdsList = res.data
      }
    },
    async getTeamIds() {
      const res = await getDeptDropdown({
        parentIds: this.inputFrom.deptIds,
      })
      this.teamIdsList = res.data
      if (this.teamIdsList.length == 0) {
        this.getAllPositionByDeptId(1)
      }
    },
    async queryAllShfitManage() {
      const res = await queryAllShfitManage()
      this.classesList = res.data
      this.shiftManageList = res.data
    },
    // 根据部门id查询岗位
    async getAllPositionByDeptId(val) {
      // if (this.inputFrom.deptIds && !this.inputFrom.deptIds.length) {
      //   return (this.inputFrom.positionIds = [])
      // }
      let params = {}
      if (this.inputFrom.teamIds && this.inputFrom.teamIds.length > 0) {
        params.deptIds = this.inputFrom.teamIds
      } else if (this.inputFrom.deptIds && this.inputFrom.deptIds.length > 0) {
        params.deptIds = this.inputFrom.deptIds
      } else {
        params.deptIds = this.inputFrom.businessUnitIds
      }

      const res = await getAllPositionByDeptId(params)
      this.positionList = res.data
    },
    // 菜单右键
    contextMenuClickEvent({ menu, row, column }) {
      switch (menu.code) {
        case 'rest':
          // 示例
          this.getTableList()
          break
        case 'edit':
          // 示例
          this.$emit('edit', row)
          break
        case 'del':
          // 示例
          this.$emit('del', row)
          break
        case 'copy':
          // 示例
          if (row && column) {
            this.copyToClipboard(this.copyText)
          }

          break
        case 'paste':
          this.inputFrom[column.field] = this.copyText
          this.inputFrom = { ...this.inputFrom }
        default:
        // this.$XModal.message(`点击了 ${menu.name} 选项`)
      }
    },

    handleContextmenu(e) {
      if (e.target.className !== 'el-input__inner') {
        this.copyText = e.target.textContent
      }
    },
    copyToClipboard(text) {
      if (navigator.clipboard) {
        // 检查浏览器是否支持剪贴板 API
        navigator.clipboard
          .writeText(text)
          .then(() => {
            this.$message({ message: '内容已复制到剪贴板', type: 'success' })
          })
          .catch((err) => {
            console.error('无法复制内容到剪贴板:', err)
          })
      } else {
        // 如果浏览器不支持剪贴板 API，可以使用其他方法，比如创建一个临时的 textarea 并选中复制
        const textArea = document.createElement('textarea')
        textArea.style.position = 'fixed'
        textArea.style.top = 0
        textArea.style.left = 0
        textArea.style.width = '2em'
        textArea.style.height = '2em'
        textArea.style.padding = 0
        textArea.style.border = 'none'
        textArea.style.outline = 'none'
        textArea.style.boxShadow = 'none'
        textArea.style.background = 'transparent'
        textArea.value = text
        document.body.appendChild(textArea)
        textArea.focus()
        textArea.select()
        try {
          const successful = document.execCommand('copy')
          const msg = successful ? '成功复制' : '复制失败'
          this.$message({
            message: msg,
            type: successful ? 'success' : 'warning',
          })
        } catch (err) {}

        document.body.removeChild(textArea)
      }
    },
    getDeptIds(e) {
      this.inputFrom.deptIds = e
      this.getTableList()
    },
    // 联络通知单状态下拉
    async queryCommunicationOrderDropdown() {
      const res = await queryCommunicationOrderDropdown()
      this.recruitmentMethodList = res.data.checkStatusList?.map((item) => {
        return {
          name: item,
          code: item,
        }
      })
    },
    getTableList(pageType) {
      clearTimeout(this.timeout)
      this.timeout = setTimeout(() => {
        this.options.tableLoading = true
        let params = {
          // type: 1,
          limit: this.tablePage1.pageSize,
          ...this.inputFrom,
          visitPath: this.$route.path,
        }
        if (pageType == 2) {
          params.page = this.tablePage1.currentPage
        } else {
          this.tablePage1.currentPage = 1
          params.page = 1
        }
        this.isAttendanceDay && this.getAttendanceDayList()
        if (this.tableHeader.find((ele) => ele.title == '审批状态')) {
          this.queryCheckStatusList()
        }
        http.post(this.url, params).then((data) => {
          let dataList = data.data.list || data.data
          this.options.dataList = dataList
          this.tablePage1.totalResult = data.data.total
          // if (data.data.pageNum !== 1 && data.data.size === 0) {
          //   this.tablePage1.currentPage -= 1
          //   this.getTableList()
          // }
          let kongString = 'id'
          let obj = {}
          obj[kongString] = null
          // if (this.options.dataList) this.options.dataList.unshift(obj) // 插入一个空对象
          this.options.tableLoading = false
          console.log('this.options.tableLoading', this.options.tableLoading)

          // 分页后保持选中
          this.$nextTick(() => {
            this.options.dataList.forEach((item) => {
              if (this.selectSet.has(String(item.id))) {
                this.$refs.xTable1.setCheckboxRow(
                  this.$refs.xTable1.getRowById(item.id),
                  true
                )
              }
            })
          })
          this.$emit('clearUpdate')
        })

        this.clearCheckboxRow()
      }, 500)
    },
    // 高亮指定行
    getRowClassName({ row, rowIndex }) {
      let a = ''
      if (Object.keys(this.currentObj).length > 0) {
        for (const key in this.currentObj) {
          const value = this.currentObj[key]
          switch (row[key]) {
            case '是':
              a = 'current-active'
              break
            case '异常':
              a = 'error-current-active'
              break
          }
        }
      }
      return a
    },
    // 取消高亮行
    clearCurrentRow() {
      this.$refs.xTable1 && this.$refs.xTable1.clearCurrentRow()
    },
    // 取消选中
    clearCheckboxRow() {
      this.$refs.xTable1 && this.$refs.xTable1.clearCheckboxRow()
    },
    // 清空勾选框缓存
    clearSelectSet() {
      this.selectSet.clear()
      this.selectData = []
    },
    handlePageChange1({ currentPage, pageSize }) {
      this.tablePage1.currentPage = currentPage
      this.tablePage1.pageSize = pageSize
      this.getTableList(2)
    },
    //拿到多选选中的数据
    selectChangeEvent({ rowid, row, checked }) {
      if (checked) {
        this.selectSet.add(String(rowid))
        this.selectData.push(row) //同步添加整条数据
      } else {
        const isDelete = this.selectSet.delete(String(rowid))
        if (isDelete) {
          // 同步删除选中数据
          this.selectData.forEach((item, index) => {
            if (item.id == rowid) {
              this.selectData.splice(index, 1)
            }
          })
        }
      }
      console.log('this.selectData', this.selectData)
      this.$emit('selectArr', this.selectData)
    },
    // 全选
    changeMultpleCheck({ records, checked }) {
      if (checked) {
        // 全部选中
        records.forEach((item) => {
          this.selectSet.add(String(item.id))
          this.selectData.push(item)
        })
      } else {
        // 全部取消选中
        this.clearCheckboxRow()
        // 循环删除selectSet与selectData临时存储数据
        this.options.dataList.forEach((item, index) => {
          this.selectSet.delete(String(item.id))
          for (let i = 0; i < this.selectData.length; i++) {
            if (item.id == this.selectData[i].id) {
              this.selectData.splice(i, 1)
            }
          }
        })
      }
      this.$emit('selectArr', this.selectData)
    },
    radioChangeEvent({ row }) {
      this.$emit('selectRadio', row)
    },
    clear() {
      this.createDate = []
      this.updateDate = []
      this.clockDate = []
      this.useTime = []
      this.attendDate = []
      this.guestArrivalTime = []
      this.applyDate = []
      this.inputFrom = Object.assign(this.searchForm)
      this.dateList = {
        dealTime: [this.inputFrom.dealStartTime, this.inputFrom.dealEndTime],
      }
      this.$emit('clear')
      this.getTableList()
    },
    cellClick(scope) {
      this.$emit('dataReceived', scope.row)
    },

    cellDblclick(scope) {
      this.$emit('ablclickFn', scope.row)
    },
    __calculateHeight() {
      // 根据屏幕高度算表格高度
      if (window.innerHeight < 800) {
        this.options.maxHeight = 350
        this.options.height = '100%'
        this.options.minHeight = '96%'
      } else {
        this.options.maxHeight = 500
        this.options.height = '100%'
        this.options.minHeight = '96%'
      }
    },
    // 合并行
    mergeRowMethod({ row, _rowIndex, column, visibleData }) {
      if (!this.mergeRow) return
      // console.log(column.field)
      if (column.field == 'photo') {
        return {
          rowspan: 0,
          colspan: 1,
        }
      } else {
        const fields = [this.mergeRow]
        const cellValue = row[column.field]
        if (cellValue && fields.includes(column.field)) {
          const prevRow = visibleData[_rowIndex - 1]
          let nextRow = visibleData[_rowIndex + 1]
          if (prevRow && prevRow[column.field] === cellValue) {
            return { rowspan: 0, colspan: 0 }
          } else {
            let countRowspan = 1
            while (nextRow && nextRow[column.field] === cellValue) {
              nextRow = visibleData[++countRowspan + _rowIndex]
            }
            if (countRowspan > 1) {
              return { rowspan: countRowspan, colspan: 1 }
            }
          }
        }
      }
    },
    // 设置行颜色
    rowStyle({ row }) {
      if (row.redFlag) {
        return {
          // backgroundColor: '#F56C6C',
          color: '#F56C6C',
        }
      }
      // 所有离职人员
      if (row.contractStatus == '0602') {
        return {
          // backgroundColor: '#F56C6C',
          color: '#F56C6C',
        }
      }
      if (row.status == '4101' && this.isColor) {
        return {
          // backgroundColor: '#67C23A',
          color: '#67C23A',
        }
      }
      if (row.status == '4103' && this.isColor) {
        return {
          // backgroundColor: '#F56C6C',
          color: '#F56C6C',
        }
      }
      // 招聘暂停
      if (row.recruitmentStatus == '3002' && this.isColor) {
        return {
          backgroundColor: '#F2F2F2',
        }
      }
      // 招聘完成
      if (
        (row.recruitmentStatus == '3003' || row.recruitmentStatus == '3004') &&
        this.isColor
      ) {
        return {
          backgroundColor: '#C8EFD4',
        }
      }
      // 异常就餐列表
      if (row.redFlag == '1' && this.isColor) {
        return {
          backgroundColor: '#F56C6C',
        }
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.mytable-scrollbar {
  ::-webkit-scrollbar {
    width: 10px;
    height: 10px;
  }
  // ::-webkit-scrollbar-thumb {
  //   border-radius: 5px;
  // }
}
.baseDataList {
  position: relative;
  height: calc(100% - 20px);
  ::-webkit-scrollbar {
    // fixed固定，改变底部滑轮样式
    position: fixed;
    bottom: 0;
  }
  ::v-deep .el-card__body {
    height: 100%;
  }
  ::v-deep tbody {
    tr:nth-child(1) {
      background-color: #fff;
      // height: 48px !important;
      // border: 1px solid red;
      // td {
      //   height: 40px !important;
      // }
      // .c--tooltip {
      //   padding: 0;
      // }
      // .vxe-tree-cell {
      //   padding: 0;
      // }

      .vxe-cell {
        // padding: 0 !important;
        .vxe-cell--tree-node {
          width: 100%;
          .vxe-tree-cell {
            flex: 1;
          }
        }
      }
      .el-input__inner {
        border: 0;
        &:focus {
          border: 2px solid #409eff;
          border-radius: 0;
        }
      }
    }
  }
}
.buttons {
  margin-bottom: 20px;
}
::v-deep .vxe-table .vxe-body--column {
  height: 30px;
  line-height: 30px;
}
::v-deep .vxe-cell--tree-node {
  display: flex;
  align-items: center;
  height: 100%;
  width: 100%;
}

::v-deeep .vxe-cell {
  width: 100%;
  display: flex !important;
  align-items: center;
}

::v-deep .vxe-body--column {
  border-left: 1px solid rgb(244, 245, 247) !important;
  border-bottom: 1px solid rgb(244, 245, 247) !important;
}
::v-deep th.vxe-header--column {
  border-left: 1px solid #ccc !important;
  border-bottom: 2px solid rgb(244, 245, 247) !important;
}

::v-deep .vxe-table--resizable-bar {
  border: 1px solid rgb(63, 158, 255) !important;
}
::v-deep .vxe-table--fixed-right-wrapper {
  height: 99% !important;
}
::v-deep .vxe-table--fixed-left-wrapper {
  height: 99% !important;
}
::v-deep .vxe-pager {
  height: 0;
}
::v-deep .el-range-separator {
  width: fit-content;
}
.export_btn {
  position: absolute;
  top: -33px;
}
.vxe_toolbar_box {
  margin-top: -51px;
  // width: 200px;
  width: 36px;
  float: right;
}
.search_btn_border {
  ::v-deep button {
    border-top: 0;
    border-bottom: 1px solid #dcdfe6;
  }
}
::v-deep .vxe-table--render-default .vxe-body--row.row--current {
  background-color: #a0cfff !important;
}
::v-deep .vxe-table--render-default .vxe-header--column .vxe-cell {
  display: flex;
  align-items: center;
  justify-content: center;
  // height: 80px;
}

.h_80 {
  height: 80px;
}

.h_44 {
  height: 44px;
}
.table_column_title_text {
  height: 30px;
}
::v-deep .current-active {
  background: rgba(103, 194, 58, 0.6) !important;
}
::v-deep .error-current-active {
  background: rgba(245, 108, 108, 0.6) !important;
}
</style>
